<style lang='less'>
.app-logo{
  font-family: Futura,Helvetica Neue For Number,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif;
  font-size: 20px;
  padding: 0px 24px;
  margin-bottom: 15px;
  line-height: @layout-header-height;
  height: @layout-header-height;
  overflow: hidden;
  white-space: nowrap;
  transition: padding .3s;
}
.logo-img{
    margin: 9px auto 0;
    height: 24px;
}
.logo-simbolo-img{
    margin-left: 18px;
    margin-top: 10px;
    height: 24px;
}
.app-bg {
  height: 45px;
  background: #3c454f;
}
</style>
<template>
  <div class="app-logo text-center"><router-link to="/">
    <template v-if="!siderCollapsed">
      <img :src="`${require(`@/images/white/logo.png`)}`" class="logo-img">
    </template>
    <template v-else>
      <img alt="logo f360" :src="`${require(`@/images/white/simbolo.png`)}`" class="logo-simbolo-img">
    </template>
  </router-link></div>
</template>
<script>
export default {
  props: ['theme'],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    siderCollapsed: {
      get() {
        return this.$store.state.siderCollapsed;
      }
    }
  }
};
</script>
